import React from "react";
const Main = () => <h1>Fournisseurs Page</h1>;
export default Main;